import { ROUTE_WE_SPIN_GAME_ROOM } from '~/components/we-spin/new-flow/constants/we-spin-route-constants.js';
import {
	ROUTE_TOURNAMENT_LOBBY,
	ROUTE_ENDED_TOURNAMENTS,
	ROUTE_TOURNAMENT_RESULTS
} from '~/components/casino-shared/tournaments/routes';
import { ROUTE_EXTERNAL_LOGIN } from '../router/constants';

export default [
	'account',
	'authentication',
	'login',
	'start',
	'play-as-guest',
	'external-request',
	'register',
	'step',
	'welcome',
	'reset-password-start',
	'reset-password-email',
	'reset-password-phone',
	'reset-password-code',
	'reset-password-welcome',
	'reset-password-dob-verification',
	'new-password',
	'shop-item-detail',
	'support',
	'guest-deposit-login',
	'guest-instant-deposit-page',
	'guest-login-verify-account',
	'guest-deposit-login-result',
	'payment/result',
	'account/my-limits/:returnTo?',
	'account/settings',
	'account/email-verification-success',
	'account/email-verification-failed',
	'account/email-already-verified',
	'privacy-policy-sidebar',
	'cookie-policy-sidebar',
	'terms-and-conditions-sidebar',
	'terms-and-conditions-bonus-sidebar',
	'points-faq',
	ROUTE_WE_SPIN_GAME_ROOM,
	'account/my-notifications',
	'account/my-notifications/:notificationId?',
	'auth-res-gaming',
	'account/complete-verifications',
	'account/email',
	'account/mobile',
	ROUTE_TOURNAMENT_LOBBY.substring(1),
	ROUTE_EXTERNAL_LOGIN.substring(1),
	ROUTE_ENDED_TOURNAMENTS.substring(1),
	ROUTE_TOURNAMENT_RESULTS.substring(1)
].map(i => `/${i}`);
